import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { sellerHelpUrl } from '@shared/utils/seller-help-url';

/** Старые закладки seller.../help → публичная справка на основном домене. */
export default function SellerHelpRedirectPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    window.location.replace(sellerHelpUrl(searchParams.get('q')));
  }, [searchParams]);

  return (
    <p style={{ margin: '2rem', fontFamily: 'system-ui, sans-serif' }}>
      Переходим в справку…
    </p>
  );
}
